(function () {
  const storageKey = `collection-scroll-${window.location.pathname}`;
  const savedScroll = sessionStorage.getItem(storageKey);

  if (savedScroll) {
    window.setTimeout(() => {
      window.scrollTo(0, Number.parseInt(savedScroll, 10));
    }, 300);
  }

  const saveScrollPosition = () => {
    sessionStorage.setItem(storageKey, window.scrollY);
  };

  window.addEventListener('beforeunload', saveScrollPosition);

  document.querySelectorAll('a[href*="/products/"]').forEach((link) => {
    link.addEventListener('click', saveScrollPosition);
  });
})();
